import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp } = FiIcons;

const ComplianceTrendChart = ({ records = [] }) => {
  const { months, compliantTrend, overdueTrend, inProgressTrend } = useMemo(() => {
    const m = [];
    const compT = [];
    const overT = [];
    const inProgT = [];

    const today = new Date();
    for (let i = 5; i >= 0; i--) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      m.push(d.toLocaleString('default', { month: 'short' }));
      
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() - i + 1, 0);
      
      const relevantRecords = records.filter(r => {
        if (!r.dueDate) return false;
        return new Date(r.dueDate) <= endOfMonth;
      });

      if (relevantRecords.length === 0) {
        compT.push(0);
        overT.push(0);
        inProgT.push(0);
        continue;
      }

      let comp = 0;
      let over = 0;
      let inProg = 0;

      relevantRecords.forEach(r => {
        if (r.complianceStatus === 'Compliant') comp++;
        else if (r.complianceStatus === 'Overdue') over++;
        else inProg++;
      });

      compT.push(Math.round((comp / relevantRecords.length) * 100));
      overT.push(Math.round((over / relevantRecords.length) * 100));
      inProgT.push(Math.round((inProg / relevantRecords.length) * 100));
    }
    return { months: m, compliantTrend: compT, overdueTrend: overT, inProgressTrend: inProgT };
  }, [records]);

  const option = {
    tooltip: { trigger: 'axis', formatter: (p) => p.map(s => `${s.marker}${s.seriesName}: <b>${s.value}%</b>`).join('<br/>') },
    legend: { data: ['Compliant %', 'Overdue %', 'In Progress %'], bottom: 0, textStyle: { fontSize: 11 } },
    grid: { left: '3%', right: '4%', bottom: '18%', top: '5%', containLabel: true },
    xAxis: { type: 'category', data: months, axisLabel: { fontSize: 11 }, axisLine: { lineStyle: { color: '#e2e8f0' } } },
    yAxis: { type: 'value', max: 100, axisLabel: { formatter: '{value}%', fontSize: 10 }, splitLine: { lineStyle: { color: '#f1f5f9' } } },
    series: [
      { name: 'Compliant %', type: 'line', data: compliantTrend, smooth: true, itemStyle: { color: '#10b981' }, lineStyle: { color: '#10b981', width: 2.5 }, areaStyle: { color: 'rgba(16,185,129,0.08)' }, symbol: 'circle', symbolSize: 5 },
      { name: 'Overdue %', type: 'line', data: overdueTrend, smooth: true, itemStyle: { color: '#ef4444' }, lineStyle: { color: '#ef4444', width: 2.5 }, areaStyle: { color: 'rgba(239,68,68,0.06)' }, symbol: 'circle', symbolSize: 5 },
      { name: 'In Progress %', type: 'line', data: inProgressTrend, smooth: true, itemStyle: { color: '#3b82f6' }, lineStyle: { color: '#3b82f6', width: 2, dash: [4, 3] }, symbol: 'circle', symbolSize: 5 },
    ]
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-4">
        <SafeIcon icon={FiTrendingUp} className="text-emerald-500" />
        <h3 className="text-sm font-semibold text-slate-700">Compliance Trend (6 months)</h3>
      </div>
      <ReactECharts option={option} style={{ height: 220 }} />
    </div>
  );
};

export default ComplianceTrendChart;